import type { ComboboxOptionProps as HeadlessComboboxOptionProps } from "@headlessui/react";
import { ComboboxOption } from "./ComboboxOption";

const ACTION_PREFIX = "action:";

export const isComboboxAction = (value: string | Array<string>) => {
  const values = Array.isArray(value) ? value : [value];

  return values.some((v) => v?.startsWith(ACTION_PREFIX));
};

export const removeComboboxActionPrefix = (value: string | Array<string>) => {
  const action = Array.isArray(value)
    ? (value.find((v) => v?.startsWith(ACTION_PREFIX)) ?? "")
    : value;

  return action.replace(ACTION_PREFIX, "");
};

export function ComboboxAction(props: HeadlessComboboxOptionProps) {
  return <ComboboxOption {...props} value={`${ACTION_PREFIX}${props.value}`} />;
}
